/**
 * handlers.callResult.ts — offline replay for the PREQUAL/CALLING call-result
 * INSERT.
 *
 * Charter: ONE bounded context — the `POST /v1/calling/calls` write that ends a
 * call. Registered by the `./handlers` facade.
 */

import { registerQueueHandler } from './offlineQueue'
import { submitCallResultBody } from '../api/callResults'
import type { CallResultQueuePayload } from '../api/callResults'
import { QUEUE_TYPES } from './queueTypes'

/**
 * Call-result submit — the prequal/calling `POST /v1/calling/calls` INSERT
 * (FR-FE-WRITE-PATH-ASSURANCE-2026-07-12). The stored body is the flat,
 * already-built wire body (submitBodyBuilders.ts); replaying it verbatim
 * re-POSTs the same columns the online attempt sent. The write travels
 * `durableSubmit`, so this handler is the ONLINE-and-replay leg of that one
 * outbox — never a second, bespoke submit surface.
 */
export type CallResultSubmitQueuePayload = CallResultQueuePayload

export function registerCallResultHandlers(): void {
  // Replay the /v1/calling/calls INSERT that failed transiently at submit
  // (network drop / 5xx). The body is the flat wire body built at submit time;
  // replaying it re-POSTs the same columns. The SL's
  // trg_sync_queue_on_call_result advances the call_queue on insert, so a
  // duplicate-safe replay is the caller's concern (SL upsert semantics).
  registerQueueHandler(QUEUE_TYPES.CALL_RESULT_SUBMIT, async (payload) => {
    const p = payload as CallResultSubmitQueuePayload
    await submitCallResultBody(p)
  })
}
